import React from "react";
import { VpnSettingsComponent } from "./vpn-settings.component";

export const VpnSettingsPage = () => <VpnSettingsComponent />;
